import { TODO } from '@b2b/types/core/utils';
import angular, { IScope } from 'angular';

export const InputFieldDirectiveModule = angular
  .module('acme.common.directive.inputField', [
    'acme.common.directive.fieldFocus',
    'acme.common.directive.capitalize',
    'acme.common.directive.numeric',
  ])
  .directive('inputField', [
    function InputFieldDirective() {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'common/directives/inputField/inputField.tpl.html',
        scope: {
          type: '@',
          name: '@',
          label: '@',
          addon: '@',
          icon: '@',
          useFullWidth: '@', // Used in conjunction with maxlength to prevent constrained width
          model: '=',
          disabled: '=',
          useCancel: '@',
          setFieldFocus: '@setfieldfocus',
          fieldFocusTimeout: '@',
          maxLength: '@maxlength',
          hasAddon: '@hasaddon',
          hideLabel: '@hidelabel',
          validTest: '=validtest',
          errorMessage: '=errormessage',
          isPanelGroup: '@ispanelgroup',
          placeholderValue: '@placeholdervalue',
          required: '@',
          numericOnly: '<',
        },
        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          function InputFieldController(
            $scope: IScope & {
              inputField: TODO;
              setFieldFocus: TODO;
              placeholderValue: TODO;
              isPanelGroup: TODO;
              fieldFocusTimeout: TODO;
              numericOnly: TODO;
              label: TODO;
              validTest: TODO;
              model: TODO;
              hasAddon: TODO;
            }
          ) {
            $scope.inputField = {
              setFieldFocus: $scope.setFieldFocus,
              placeholder: $scope.placeholderValue || '',
              groupTypeClass: $scope.isPanelGroup ? 'panel-form-group' : 'form-group',
              fieldFocusTimeout: $scope.fieldFocusTimeout ? $scope.fieldFocusTimeout : 0,
              numericOnly: $scope.numericOnly === true,

              label: $scope.label || $scope.placeholderValue || '',

              init: function () {},

              checkValid: function () {
                return $scope.validTest !== undefined ? $scope.validTest : true;
              },

              clear: function (name) {
                $scope.model = '';
                if (name) {
                  $('#input-' + name + ($scope.hasAddon ? '-addon' : '')).focus();
                }
              },
            };

            $scope.inputField.init();
          },
        ],
      };
    },
  ]).name;
